const indexItems = [
  { name: '动作电影', count: '1,286部', icon: 'ri-film-line', color: 'primary' },
  { name: '悬疑剧集', count: '863部', icon: 'ri-search-eye-line', color: 'accent' },
  { name: '喜剧综艺', count: '452部', icon: 'ri-emotion-happy-line', color: 'secondary' },
  { name: '科幻大片', count: '598部', icon: 'ri-rocket-line', color: 'primary' },
  { name: '古装剧集', count: '721部', icon: 'ri-ancient-gate-line', color: 'accent' },
  { name: '动漫番剧', count: '1,045部', icon: 'ri-ghost-smile-line', color: 'secondary' },
  { name: '纪录纪实', count: '367部', icon: 'ri-earth-line', color: 'primary' },
  { name: '爱情影视', count: '934部', icon: 'ri-heart-line', color: 'accent' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            影视索引
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            按类型快速查找，海量内容精准定位
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200 rounded-xl p-5 hover:border-primary-300 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-lg mb-3 ${
                  item.color === 'primary'
                    ? 'bg-primary-100 text-primary-600'
                    : item.color === 'accent'
                    ? 'bg-accent-100 text-accent-600'
                    : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">
                {item.name}
              </h3>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}